import { Tooltip, Typography } from "@mui/material";
import React from "react";
import { StyledCardTitle } from "../../../styled/accident";

const CardTitle = ({ title, color, icons = [] }) => {
  return (
    <StyledCardTitle.Container color={color}>
      <Typography component="div" variant="body2" sx={{ fontWeight: "bold", color: "white" }}>
        {title}
      </Typography>
      <StyledCardTitle.Button>
        {icons.map(({ Icon, tooltip, onClick, disabled }, index) => (
          <Tooltip
            key={index}
            title={disabled ? `${tooltip} (Deshabilitado)` : tooltip}>
            <span>
              <Icon
                sx={{ cursor: "pointer", marginLeft: 1 }}
                onClick={!disabled ? onClick : undefined}
              />
            </span>
          </Tooltip>
        ))}
      </StyledCardTitle.Button>
    </StyledCardTitle.Container>
  );
};

export default CardTitle;
